export type RoundedCheckMarkProps = {};

export function RoundedCheckMark(_props: RoundedCheckMarkProps) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 5.04004C11.6238 5.04004 9.34457 5.98404 7.66434 7.66434C5.98397 9.34462 5.04004 11.6235 5.04004 14C5.04004 16.3765 5.98404 18.6555 7.66434 20.3357C9.34462 22.0161 11.6235 22.96 14 22.96C16.3765 22.96 18.6555 22.016 20.3357 20.3357C22.0161 18.6555 22.96 16.3765 22.96 14C22.96 12.4272 22.5461 10.8822 21.7597 9.52004C20.9733 8.15796 19.8421 7.02687 18.4802 6.24054C17.1181 5.45414 15.5731 5.04016 14.0002 5.04016L14 5.04004ZM13.0088 17.9592L9.44724 14.3948L11.0321 12.81L13.0117 14.7896L16.9709 10.8332L18.5557 12.418L13.0088 17.9592Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default RoundedCheckMark;
